import {
  FETCH_EVENTS_REQUESTED,
  FETCH_EVENTS_SUCCEED,
  FETCH_EVENTS_FAIL,

  FETCH_TOP_PRO_LINK_REQUESTED,
  FETCH_TOP_PRO_LINK_SUCCEED,
  FETCH_TOP_PRO_LINK_FAIL,

  FETCH_CLIENT_FUNNEL_REQUESTED,
  FETCH_CLIENT_FUNNEL_SUCCEED,
  FETCH_CLIENT_FUNNEL_FAIL,
  FETCH_STATISTIC_SUCCEED,
  FETCH_STATISTIC_FAIL,
  FETCH_STATISTIC_REQUESTED,
} from './actionTypes';

const AnalyticsErrors = {
  fetchEventsFailed: 'Не удалось обновить список событий.',
  editEventFailed: 'Не удалось сохранить данные события.'
}
//
// export const editEvent = (editedEvent, successCallback, errorCallback) => {
//   return (dispatch) => {
//     const eventData = {
//       id: editedEvent.id,
//       internal_description: editedEvent.internal_description || null,
//     }
//
//     SarafanApiClient.analyticsEdit(eventData)
//       .then((response) => {
//         if (response &&
//           typeof(response.body) === 'object' &&
//           response.body.is_successful &&
//           typeof(response.body.data) === 'object') {
//
//           dispatch({
//             type: actionTypes.UPDATE_EVENT,
//             event: response.body.data,
//           })
//           successCallback()
//         } else {
//           errorCallback(AnalyticsErrors.editEventFailed)
//         }
//
//       })
//       .catch((error) => {
//         errorCallback(AnalyticsErrors.editEventFailed)
//       })
//   }
// }
//

//
// export const fetchClientFunnel = (successCallback, errorCallback) => {
//     return (dispatch) => {
//         SarafanApiClient.clientFunnel()
//             .then((response) => {
//                 if (response &&
//                     typeof(response.body) === 'object' &&
//                     Array.isArray(response.body.data))
//                 {
//                     successCallback(response.body.data)
//                 } else {
//                     errorCallback(AnalyticsErrors.fetchEventsFailed)
//                 }
//
//             })
//             .catch((error) => {
//                 errorCallback(AnalyticsErrors.fetchEventsFailed)
//             })
//     }
// }
//


export function fetchEventsRequested(params) {
  return {
    type: FETCH_EVENTS_REQUESTED,
    payload: params,
  };
}

export function fetchEventsSucceeded(params) {
  return {
    type: FETCH_EVENTS_SUCCEED,
    payload: params,
  };
}

export function fetchEventsFailed(params) {
  return {
    type: FETCH_EVENTS_FAIL,
    payload: params,
  };
}

export function fetchStatisticRequested(params) {
  return {
    type: FETCH_STATISTIC_REQUESTED,
    payload: params,
  };
}

export function fetchStatisticSucceeded(params) {
  return {
    type: FETCH_STATISTIC_SUCCEED,
    payload: params,
  };
}

export function fetchStatisticFailed(params) {
  return {
    type: FETCH_STATISTIC_FAIL,
    payload: params,
  };
}

export function fetchTopProLinksRequested(params) {
  return {
    type: FETCH_TOP_PRO_LINK_REQUESTED,
    payload: params,
  };
}

export function fetchTopProLinksSucceeded(params) {
  return {
    type: FETCH_TOP_PRO_LINK_SUCCEED,
    payload: params,
  };
}

export function fetchTopProLinksFailed(params) {
  return {
    type: FETCH_TOP_PRO_LINK_FAIL,
    payload: params,
  };
}

export function fetchProFunnelRequested(params) {
  return {
    type: FETCH_TOP_PRO_LINK_REQUESTED,
    payload: params,
  };
}

export function fetchProFunnelSucceeded(params) {
  return {
    type: FETCH_TOP_PRO_LINK_SUCCEED,
    payload: params,
  };
}

export function fetchProFunnelFailed(params) {
  return {
    type: FETCH_TOP_PRO_LINK_FAIL,
    payload: params,
  };
}

export function fetchClientFunnelRequested(params) {
  return {
    type: FETCH_CLIENT_FUNNEL_REQUESTED,
    payload: params,
  };
}

export function fetchClientFunnelSucceeded(params) {
  return {
    type: FETCH_CLIENT_FUNNEL_SUCCEED,
    payload: params,
  };
}

export function fetchClientFunnelFailed(params) {
  return {
    type: FETCH_CLIENT_FUNNEL_FAIL,
    payload: params,
  };
}





// WEBPACK FOOTER //
// ./src/store/analytics/actions.js